import React from 'react'
import onClickOutside from 'react-onclickoutside'
import Button from '../components/button.js'
import logoFixed from '../assets/logo2.png'
import logoAtTop from '../assets/logo2-white.png'

class NavBar extends React.Component {
  state = {  // eslint-disable-line no-undef
    atTop: this.props.atTop,
    class: this.props.atTop ? 'at-top' : 'fixed',
    open: false
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.atTop !== this.state.atTop) {
      if (this.state.atTop) {
        this.setState({ class: 'hide fixed', atTop: false })
        setTimeout(() => {
          this.setState({ class: 'slow fixed' })
        }, 0)
      } else {
        this.setState({ class: 'slow hide fixed', atTop: true })
        setTimeout(() => {
          this.setState({ class: 'at-top' })
        }, 250)
      }
    }
  }

  toggle = () => {  // eslint-disable-line no-undef
    this.setState(prevState => ({open: !prevState.open}))
  }
  dismiss = () => {  // eslint-disable-line no-undef
    this.setState(_ => ({open: false}))
  }
  handleClickOutside = this.dismiss  // eslint-disable-line no-undef

  render () {
    let activeClass = this.state.open ? 'is-active' : ''
    return (
      <nav className={`navbar columns is-centered ${this.state.class}`}>
        <div className='container column'>
          <div className='navbar-brand'>
            <a className='navbar-item' href='/'>
              <img className='fixed' src={logoFixed} alt='ClearBrain' width='150' height='100' />
              <img className='at-top' src={logoAtTop} alt='ClearBrain' width='150' height='100' />
            </a>
            <div className={`navbar-burger burger ${activeClass}`} onClick={this.toggle}>
              <span />
              <span />
              <span />
            </div>
          </div>
          <div className={`navbar-menu ${activeClass}`} onClick={this.dismiss}>
            <a className='navbar-item' href='/#features'>Features</a>
            <a className='navbar-item' href='/#how-it-works'>How It Works</a>
            <a className='navbar-item' href='/#meet-our-team'>Team</a>
            <a className='navbar-item' href={this.props.jobsUrl}>Careers</a>
            <a className='navbar-item' href='https://success.clearbrain.com/' target='_blank' rel='noopener'>Docs</a>
            <a className='navbar-item' href='https://blog.clearbrain.com/' target='_blank' rel='noopener'>Blog</a>
            <div className='navbar-end has-text-weight-semibold'>
              <a className='navbar-item' href='https://app.clearbrain.com/' rel='noopener'>Log In</a>
              <Button className='navbar-item cta' text='Get Started' href={this.props.actionUrl} />
            </div>
          </div>
        </div>
      </nav>
    )
  }
}

export default onClickOutside(NavBar)



// WEBPACK FOOTER //
// ./src/components/navbar.js